var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpensearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5549 14.7692L19.8373 19.0516C20.0542 19.2686 20.0542 19.6203 19.8373 19.8373C19.6203 20.0542 19.2686 20.0542 19.0516 19.8373L14.7692 15.5549C13.2022 16.9383 11.1436 17.7778 8.88889 17.7778C3.97969 17.7778 0 13.7981 0 8.88889C0 3.97969 3.97969 0 8.88889 0C13.7981 0 17.7778 3.97969 17.7778 8.88889C17.7778 11.1436 16.9383 13.2022 15.5549 14.7692ZM8.88889 16.6667C13.1844 16.6667 16.6667 13.1844 16.6667 8.88889C16.6667 4.59334 13.1844 1.11111 8.88889 1.11111C4.59334 1.11111 1.11111 4.59334 1.11111 8.88889C1.11111 13.1844 4.59334 16.6667 8.88889 16.6667Z",
    fill: "#87888A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensearch);
export default __webpack_public_path__ + "static/media/opensearch.c8a4a94aab746e692af203cfc494ac68.svg";
export { ForwardRef as ReactComponent };